
const EditSale = () => import("./sales/index.vue");
const ViewEditInvoice = () => import("./sales/view.vue");

const EditPurchase = () => import("./purchases/index.vue");
const PurchaseInvoice = () => import("./purchases/view.vue");

const StockTransferIndex = () => import("./stock-transfer/index.vue");
const StockTransfer = () => import("./stock-transfer/view.vue");

const JournalEntryIndex = () => import("./journal-entry/index.vue");
const JournalEntry = () => import("./journal-entry/view.vue");

// payments editing
const CancelPayments = () => import("./payments/index.vue");
const CancelSalePayments = () => import("./payments/sale-payments.vue");
const CancelPurchasePayments = () => import("./payments/purchase-payments.vue");
// adjust stock
const AdjustStock = () => import("./adjust-stock/index.vue");
const AdjustStockMultiple = () => import("./adjust-stock/multiple.vue");
const AdjustmentMissing = () => import("./adjust-stock/adjustment-missing.vue");

export default [
  {
    path: "/cancel-payments",
    component: CancelPayments,
  },
  {
    path: "/cancel-sale-payments",
    component: CancelSalePayments,
  },
  {
    path: "/cancel-purchase-payments",
    component: CancelPurchasePayments,
  },
  {
    path: "/edit-sale",
    component: EditSale,
  },
  {
    path: "/edit-sale/:id",
    component: ViewEditInvoice,
  },
  {
    path: "/edit-purchase",
    component: EditPurchase,
  },
  {
    path: "/edit-purchase/:id",
    component: PurchaseInvoice,
  },
  {
    path: "/edit/stock/transfer",
    component: StockTransferIndex,
  },
  {
    path: "/edit/stock/transfer/:id",
    component: StockTransfer,
  },
  {
    path: "/edit/journal/entry",
    component: JournalEntryIndex,
  },
  {
    path: "/edit/journal/entry/:id",
    component: JournalEntry,
  },
  {
    path: "/adjust-stock",
    component: AdjustStock,
  },
  {
    path: "/adjustment-missing",
    component: AdjustmentMissing,
  },
  {
    path: "/adjust-stock-multiple",
    component: AdjustStockMultiple,
  }
];
